import React from 'react';
import { Button } from '../ui/button';
import { Upload, RotateCw } from 'lucide-react';
import { getPhotoUrl } from '../../utils/photoUtils';

/**
 * Profile photo display and management component
 * Handles photo click, rotation, and change actions
 */
const ProfilePhoto = ({
  user,
  onPhotoClick,
  showPhotoDialog,
  onPhotoChangeConfirm,
  onPhotoRotate,
  onPhotoDialogClose,
  isUploadingPhoto
}) => {
  return (
    <div className="relative">
      {/* Photo Dialog */}
      {showPhotoDialog && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-6 max-w-sm w-full mx-4 space-y-4">
            <h3 className="text-xl font-semibold text-center">Profile Photo</h3>
            <div className="space-y-3">
              <Button
                onClick={onPhotoChangeConfirm}
                className="w-full bg-purple-600 hover:bg-purple-700"
              >
                <Upload className="h-5 w-5 mr-2" />
                Change Photo
              </Button>
              <Button
                onClick={onPhotoRotate}
                variant="outline"
                className="w-full"
                disabled={!user?.photos || user.photos.length === 0}
              >
                <RotateCw className="h-5 w-5 mr-2" />
                Rotate 90°
              </Button>
              <Button
                onClick={onPhotoDialogClose}
                variant="ghost"
                className="w-full"
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Photo Display */}
      <div
        onClick={onPhotoClick}
        className="w-32 h-32 mx-auto bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white text-4xl font-bold cursor-pointer hover:opacity-90 transition-opacity overflow-hidden"
      >
        {user.photos && user.photos.length > 0 ? (
          <img
            src={getPhotoUrl(user.photos[0])}
            alt={user.name}
            className="w-full h-full object-cover"
          />
        ) : (
          user.name.charAt(0).toUpperCase()
        )}
      </div>

      {isUploadingPhoto && (
        <div className="absolute inset-0 bg-black/50 rounded-full flex items-center justify-center">
          <div className="text-white text-sm">Uploading...</div>
        </div>
      )}
    </div>
  );
};

export default ProfilePhoto;
